import { useContext } from 'react';
import { LayoutContext } from 'pages/shared/Layout';

const useConfirmation = () => {
  const appContext = useContext(LayoutContext);

  const confirmation = ({
    noClick,
    yesClick,
    title,
    description,
    labelConfirm,
    labelCancel,
    hideNoButton = false,
  }) => {
    appContext.setConfirmDialog({
      title,
      description,
      open: true,
      confirm: yesClick,
      cancel: noClick,
      labelConfirm,
      labelCancel,
      hideNoButton,
    });
  };

  return { confirmation };
};

export default useConfirmation;
